import React from 'react';
import './DayInput.scss';
import { Options } from '../../core';

interface CustomProps {
  default?: Options[];
  placeholder?: string;
  onChange: (value: Options[]) => void;
  gap?: 'sm' | 'md' | 'lg';
  error?: string;
  disabled?: boolean;
  options?: Options[];
}

interface CustomState {
  value: Options[];
}

class DayInput extends React.Component<CustomProps, CustomState> {
  static defaultProps: Partial<CustomProps> = {
    gap: 'md',
    error: '',
    placeholder: '',
  };
  constructor(props: CustomProps) {
    super(props);
    this.state = {
      value: this.props.default || [],
    };
  }
  componentDidMount() {
    this.state = {
      value: this.props.default || [],
    };
  }

  componentDidUpdate(prevProps: CustomProps) {
    if (prevProps.default !== this.props.default) {
      this.updateDefault();
    }
  }

  updateDefault() {
    this.setState({
      value: this.props.default || [],
    });
  }

  handleChange = (e: React.ChangeEvent<HTMLInputElement>, day: Options) => {
    const { value } = this.state;
    if (e.target.checked) {
      value?.push(day);
    } else {
      const index = value?.map((x) => x.value).indexOf(day.value);

      if ((index || 0) > -1) {
        value?.splice(index || 0, 1);
      }
    }

    this.props.onChange?.(value?.sort((a, b) => a.order - b.order));
  };

  render() {
    const { options } = this.props;
    const { value } = this.state;

    return (
      <div className="input-group">
        {options?.map((opt: Options) => {
          return (
            <>
              <input
                type="checkbox"
                name="checkbox-option"
                className="day-input"
                id={`checkbox-button-opt-${opt.value}`}
                value={opt.value}
                onChange={(e) => {
                  this.handleChange(e, opt);
                }}
                checked={!!value.find((x) => x.value === opt.value)}
                disabled={this.props.disabled}
              />
              <label
                className="mr-2"
                htmlFor={`checkbox-button-opt-${opt.value}`}
              >
                {opt.label}
              </label>
            </>
          );
        })}
      </div>
    );
  }
}
export default DayInput;
